import { Link } from "react-router-dom";
import CouncilWheel from "@/components/council/CouncilWheel";

interface CouncilHeroSceneProps {
  onNavigateToSection?: (index: number) => void;
}

export default function CouncilHeroScene({ onNavigateToSection }: CouncilHeroSceneProps) {
  return (
    <section id="hero" className="relative min-h-screen w-full flex items-center">
      <div id="problem" aria-hidden className="absolute top-0 left-0 w-px h-px" />

      <div className="w-full max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16 items-center">
        {/* LEFT */}
        <div>
          <p
            className="font-mono"
            style={{
              fontSize: 11,
              letterSpacing: "0.14em",
              color: "hsl(var(--manuscript) / 0.55)",
            }}
          >
            <span className="font-dev" style={{ color: "hsl(var(--lens-ram))", fontSize: 16 }}>
              उलझन
            </span>{" "}
            · uljhan — you arrive carrying something unresolved
          </p>

          <h1
            className="font-display mt-6"
            style={{
              fontSize: "clamp(2.2rem, 5vw, 3.9rem)",
              lineHeight: 1.08,
              letterSpacing: "-0.02em",
              color: "hsl(var(--manuscript))",
            }}
          >
            Make better decisions{" "}
            <em style={{ color: "hsl(var(--marigold))" }}>when life feels unclear.</em>
          </h1>

          <p
            className="mt-6 max-w-xl"
            style={{
              fontSize: "clamp(0.98rem, 1.3vw, 1.1rem)",
              lineHeight: 1.7,
              color: "hsl(var(--manuscript) / 0.7)",
            }}
          >
            Outspoken helps you think clearly about career, relationships, money, and pressure —
            using Indian wisdom, translated into plain language for real life.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-5">
            <Link id="hero-primary-cta" to="/onboarding" className="btn-primary w-full sm:w-auto text-center">
              Start a Session
            </Link>
            <button
              onClick={() => onNavigateToSection?.(4)}
              className="group inline-flex items-baseline gap-3 text-manuscript/75 hover:text-manuscript transition-colors"
            >
              <span
                aria-hidden
                className="block h-px w-7 transition-all duration-300 group-hover:w-10"
                style={{ background: "hsl(var(--manuscript) / 0.5)" }}
              />
              <span
                className="font-display italic"
                style={{ fontSize: "clamp(1rem,1.2vw,1.1rem)" }}
              >
                See how it works
              </span>
            </button>
          </div>

          <p
            className="mt-10 font-mono uppercase"
            style={{
              fontSize: 10,
              letterSpacing: "0.3em",
              color: "hsl(var(--manuscript) / 0.35)",
            }}
          >
            No predictions · No superstition · No fluff
          </p>
        </div>

        {/* RIGHT */}
        <div className="w-full">
          <CouncilWheel />
        </div>
      </div>
    </section>
  );
}
